<script setup>
import { useRoute } from "vue-router";
import { useStore } from "vuex";

import SidenavItem from "./SidenavItem.vue";
import { ROLES } from "@/services/acl";

const store = useStore();
const can = (role) => store.getters.hasRole(role);

const getRoute = () => {
  const route = useRoute();
  const routeArr = route.path.split("/");
  return routeArr[1];
};
</script>
<template>
  <div class="collapse navbar-collapse w-auto h-auto h-100" id="sidenav-collapse-main">
    <ul class="navbar-nav">
      <li class="nav-item">
        <sidenav-item to="/dashboard" :class="getRoute() === 'dashboard' ? 'active' : ''" navText="Dashboard">
          <template v-slot:icon>
            <i class="ni ni-tv-2 text-primary text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>

      <li class="nav-item" v-if="can(ROLES.ANALYSIS_INDEX)">
        <sidenav-item to="/analysis" :class="getRoute() === 'analysis' ? 'active' : ''" navText="Analysis">
          <template v-slot:icon>
            <i class="ni ni-chart-bar-32 text-primary text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>

      <li class="nav-item" v-if="can(ROLES.USER_INDEX)">
        <sidenav-item to="/users" :class="getRoute() === 'users' ? 'active' : ''" navText="Users">
          <template v-slot:icon>
            <i class="ni ni-circle-08 text-info text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>

      <li class="nav-item" v-if="can(ROLES.VERIFICATION_INDEX)">
        <sidenav-item to="/verification" :class="getRoute() === 'verification' ? 'active' : ''" navText="Verification">
          <template v-slot:icon>
            <i class="ni ni-badge text-success text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>

      <li class="nav-item" v-if="can(ROLES.COMPLAINT_INDEX)">
        <sidenav-item to="/complaints" :class="getRoute() === 'complaints' ? 'active' : ''" navText="Complaints">
          <template v-slot:icon>
            <i class="ni ni-notification-70 text-warning text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>

      <li class="nav-item" v-if="can(ROLES.SUPPORT_INDEX)">
        <sidenav-item to="/support" :class="getRoute() === 'support' ? 'active' : ''" navText="Support">
          <template v-slot:icon>
            <i class="ni ni-support-16 text-warning text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>

      <li class="nav-item" v-if="can(ROLES.EMAIL_MANAGEMENT_INDEX)">
        <sidenav-item to="/email" :class="getRoute() === 'email' ? 'active' : ''" navText="Email Inbox">
          <template v-slot:icon>
            <i class="ni ni-email-83 text-info text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>

      <li class="nav-item" v-if="can(ROLES.COMPLIANCE_RULE_INDEX)">
        <sidenav-item to="/compliance-rules" :class="getRoute() === 'compliance-rules' ? 'active' : ''"
          navText="Compliance Rules">
          <template v-slot:icon>
            <i class="ni ni-check-bold text-success text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>

      <li class="nav-item" v-if="can(ROLES.MEDIA_COMPLIANCE_RULE_INDEX)">
        <sidenav-item to="/media-compliance-rules" :class="getRoute() === 'media-compliance-rules' ? 'active' : ''"
          navText="Media Compliance Rules">
          <template v-slot:icon>
            <i class="ni ni-image text-success text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>

      <li class="nav-item" v-if="can(ROLES.ADS_INDEX)">
        <sidenav-item to="/ads" :class="getRoute() === 'ads' ? 'active' : ''" navText="Ads">
          <template v-slot:icon>
            <i class="ni ni-tag text-primary text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>

      <li class="nav-item" v-if="can(ROLES.GROWTH_INDEX)">
        <sidenav-item to="/referrals" :class="getRoute() === 'referrals' ? 'active' : ''" navText="Referral">
          <template v-slot:icon>
            <i class="ni ni-diamond text-warning text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>

      <li class="nav-item" v-if="can(ROLES.PAYMENT_METHOD_INDEX)">
        <sidenav-item to="/payment-methods" :class="getRoute() === 'payment-methods' ? 'active' : ''"
          navText="Payment Methods">
          <template v-slot:icon>
            <i class="ni ni-credit-card text-success text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>

      <li class="nav-item" v-if="can(ROLES.CONFIG_INDEX)">
        <sidenav-item to="/config" :class="getRoute() === 'config' ? 'active' : ''" navText="Configuration">
          <template v-slot:icon>
            <i class="ni ni-settings-gear-65 text-info text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>

      <li class="nav-item" v-if="can(ROLES.ADMIN_INDEX)">
        <sidenav-item to="/admins" :class="getRoute() === 'admins' ? 'active' : ''" navText="Admins">
          <template v-slot:icon>
            <i class="ni ni-key-25 text-success text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>

      <li class="mt-3 nav-item">
        <h6 class="text-xs ps-4 text-uppercase font-weight-bolder opacity-6 ms-2">
          ACCOUNT PAGES
        </h6>
      </li>

      <li class="nav-item">
        <sidenav-item to="/signout" :class="getRoute() === 'signout' ? 'active' : ''" navText="Sign Out">
          <template v-slot:icon>
            <i class="ni ni-button-power text-danger text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>
    </ul>
  </div>
</template>
